import { matchPath } from 'react-router-dom'
import routes from '../router'

export type AppRoute = {
  key?: string
  name?: string
  textName?: string
  path?: string
  appBar?: boolean
  active?: boolean
  component?: any
}

/**
 * หา route ที่ตรงกับ pathname ปัจจุบันจากตารางเดียวกับที่ <Switch> ใช้
 *
 * AppShell วาง Header/Sidebar ไว้นอก <Switch> จึงถาม router ไม่ได้ว่า Switch เลือกลูกตัวไหน
 * (useRouteMatch นอก Switch คืน root match เสมอ) ต้องเลียนแบบการเลือกของ Switch v5 เอง:
 *
 *   const path = child.props.path || child.props.from
 *   const match = path ? matchPath(pathname, {...child.props, path}) : context.match
 *
 * จุดที่ห้ามพลาดคือ route ที่ไม่มี path — v5 ถือว่า match ทุก URL (ใช้ context.match ซึ่ง truthy เสมอ)
 * ถ้าตรงนี้คืน false จะได้ appBar/textName คนละตัวกับหน้าที่ Switch เรนเดอร์จริง
 *
 * exact: true เพราะ AppShell ส่ง exact ให้ทุก <Route>
 */
export const resolveRoute = (pathname: string): AppRoute | undefined =>
  (routes as AppRoute[]).find((route) =>
    !route.path ? true : Boolean(matchPath(pathname, { path: route.path, exact: true }))
  )
